import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../../domain/theme';
import { Ad } from '.';

const styles = {
  adInsert: css`
    text-align: center;
    clear: both;
    margin: 20px auto;
    ${theme.mq.tablet} {
      margin: 30px auto;
    }
  `
};

export const AdInsert = ({ id, content }) => (
  <div css={styles.adInsert}>
    <Ad key={id} id={id} content={content} />
  </div>
);

AdInsert.defaultProps = {
  id: undefined,
  content: undefined
};

AdInsert.propTypes = {
  id: PropTypes.string,
  content: PropTypes.objectOf(PropTypes.any)
};
